import {
  DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SETTING_BEGIN,
  DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SETTING_SUCCESS,
  DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SETTING_FAILURE,
  DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SETTING_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';

export function updateMySqlExternalDbSetting(args = {}) {
  console.log('🚀 ~ updateMySqlExternalDbSetting ~ args:', args);
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SETTING_BEGIN,
    });
    const { projectId, projectVersion, externalDbUuid, dataForUpdate } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${projectVersion}/mysql/externalDb/${externalDbUuid}/setting`,
        { dataForUpdate },
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SETTING_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SETTING_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateMySqlExternalDbSettingError() {
  return {
    type: DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SETTING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SETTING_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        updateMySqlExternalDbSettingPending: true,
        updateMySqlExternalDbSettingError: null,
      };

    case DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SETTING_SUCCESS:
      // The request is success
      return {
        ...state,
        updateMySqlExternalDbSettingPending: false,
        updateMySqlExternalDbSettingError: null,
      };

    case DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SETTING_FAILURE:
      // The request is failed
      return {
        ...state,
        updateMySqlExternalDbSettingPending: false,
        updateMySqlExternalDbSettingError: action.data.error,
      };

    case DATA_CONNECTOR_UPDATE_MY_SQL_EXTERNAL_DB_SETTING_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        updateMySqlExternalDbSettingError: null,
      };

    default:
      return state;
  }
}
